import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "height", "style", "width", "shape"];
import classnames from 'classnames';
import styled from 'foundations-theming/utils';
import { GRADIENT } from '../../styles/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const SkeletonSpan = styled.span.withConfig({
  displayName: "AISkeleton__SkeletonSpan",
  componentId: "sc-1scog5t-0"
})(["background:var(--bg-color);border-radius:0.25rem;display:inline-flex;line-height:1;overflow:hidden;position:relative;user-select:none;width:100%;z-index:1;@keyframes loading-skeleton{100%{transform:translateX(5%);}}&::after{animation:loading-skeleton 3s ease-out infinite;background-image:var(--highlight-gradient);background-repeat:no-repeat;content:' ';display:var(--animation-display);position:absolute;transform:translateX(-100%);top:", ";left:", ";right:", ";height:200%;width:400%;}@media (prefers-reduced-motion){--animation-display:none;}"], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['0']);
function getCssProperties({
  height,
  shape,
  width
}) {
  const style = {};
  if (height) {
    style.height = height;
  }
  if (width) {
    style.width = width;
  }
  if (shape === 'pill') {
    style.borderRadius = '1em';
  } else if (shape === 'circle') {
    const circleSize = width || height || '1em';
    style.borderRadius = '50%';
    style.height = circleSize;
    style.width = circleSize;
  }
  style['--highlight-gradient'] = 'linear-gradient(-45deg, #ffffff00 35%, #ffffff88 50%, #ffffff00 65%)';
  style['--bg-color'] = GRADIENT['LIGHT'];
  return style;
}
export const AISkeleton = _ref => {
  let {
      className,
      height,
      style,
      width,
      shape = 'rect'
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const skeletonStyle = Object.assign({}, style, getCssProperties({
    height,
    width,
    shape
  }));
  return /*#__PURE__*/_jsx(SkeletonSpan, Object.assign({}, restProps, {
    "aria-busy": true,
    className: classnames('loading-skeleton', className),
    role: "status",
    style: skeletonStyle,
    children: "\u200C"
  }));
};